/* eslint-disable jsx-a11y/anchor-is-valid */
import { NavLink, Outlet } from "react-router-dom";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { pathConstants } from "../../../../routes/pathContants";
import { useSelector } from "react-redux";

export const ProductPageCover = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const query = storeList?.length ? `?store_id=${storeList?.[0]?.id}` : "";

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      <div>
        <h4 className="mb-0">Products</h4>
        <p>Access and update all your product&apos;s information here</p>
      </div>

      <div className={globalStyles.rowNavigations}>
        <NavLink
          to={pathConstants.INVENTORY_PRODUCTS + query}
          className={({ isActive }) =>
            `${globalStyles.rowNavigations__item} ${isActive ? globalStyles.active : ""}`
          }
        >
          Products
        </NavLink>
        <NavLink
          to={pathConstants.INVENTORY_SERVICES + query}
          className={({ isActive }) =>
            `${globalStyles.rowNavigations__item} ${isActive ? globalStyles.active : ""}`
          }
        >
          Services
        </NavLink>
        <NavLink
          to={pathConstants.INVENTORY_COMPOSITE_PRODUCTS + query}
          className={({ isActive }) =>
            `${globalStyles.rowNavigations__item} ${isActive ? globalStyles.active : ""}`
          }
        >
          Composite
        </NavLink>
      </div>

      <Outlet />
    </div>
  );
};
